import { DownloadSharp } from '@mui/icons-material';
import { Button, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import AppConfig from '~/utils/appconfig';

const ExportButton = ({
    notExportedItemsCount,
    onOpenExportModal,
}: {
    notExportedItemsCount: number;
    onOpenExportModal: () => void;
}) => {
    const canExportToTps = AppConfig.isConnectorMode;

    return (
        <Button
            data-testid="exportButtonModal"
            fullWidth
            aria-controls="simple-menu"
            aria-haspopup="true"
            variant={notExportedItemsCount ? 'contained' : 'outlined'}
            onClick={onOpenExportModal}
            sx={{
                textTransform: 'capitalize',
                borderColor: !notExportedItemsCount
                    ? 'primary.light'
                    : 'inherit',
                color: !notExportedItemsCount ? 'primary.light' : 'inherit',
                fontSize: 12,
            }}
            startIcon={
                <DownloadSharp
                    sx={{
                        position: 'absolute',
                        left: 6,
                        top: 6,
                        height: 16,
                    }}
                />
            }
        >
            <FormattedMessage
                id={canExportToTps ? 'exportToTPS' : 'download'}
            />
            {notExportedItemsCount ? (
                <Typography
                    borderRadius={50}
                    lineHeight={1}
                    sx={{
                        position: 'absolute',
                        height: 16,
                        width: 16,
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        right: 8,
                        top: 6,
                        fontSize: 10,
                        backgroundColor: 'rgba(0,0,0, 0.50)',
                    }}
                >
                    <span data-testid="exportable-items-button-count">
                        {notExportedItemsCount}
                    </span>
                </Typography>
            ) : (
                <></>
            )}
        </Button>
    );
};

export default ExportButton;
